import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import moment from 'moment';
import NewsForm from '../../components/NewsForm';

function NewsCreatePage() {
  return (
    <div>
      <Helmet title="Create New Announcement | Manage Announcements" />
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <h2 className="page-sub-header">
              <Link to="/admin/news">All Announcements</Link>
              <span>&nbsp;<Fa name="angle-right" className="text-muted" />&nbsp;</span>
              <span>Add</span>
            </h2>
          </div>
        </div>
        <NewsForm news={{ is_visible: true, announcement_date: moment().format('YYYY-MM-DD') }} />
      </div>
    </div>
  );
}
// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

NewsCreatePage.propTypes = {
};

NewsCreatePage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(NewsCreatePage);
